







































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import FamiliesMixin from "../../mixins/http/FamiliesMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { Family } from "../../models";
import FamilyItem from "@/components/Family/Item.vue";

@Component({ components: { Page, FamilyItem } })
export default class FamilyList extends Mixins(FamiliesMixin) {
  onAdd() {
    this.$router.push({ name: "family_create" });
  }

  static readonly getFamiliesTag = "get_families_tag";
  @RegisterHttp(FamilyList.getFamiliesTag) getFamiliesRequest: RequestData;
  private families: Family[] = [];

  mounted() {
    this.loadFamilies();
  }

  get loading() {
    return this.getFamiliesRequest?.loading;
  }

  goToFamily(id) {
    this.$router.push({ name: "family", params: { id: id } });
  }

  loadFamilies() {
    this.getFamilies({}, FamilyList.getFamiliesTag).then(
      (resp) => {
        this.families = resp;
      },
      (err) => {}
    );
  }
}
